import { ControlFacet } from '../models/controls/ControlFacet';

export const itemAriaLabelControl = new ControlFacet<{
  itemKey: string;
}, {
    itemAriaLabel: string;
  }>('itemAriaLabelControl');
